document.addEventListener("DOMContentLoaded", () => {
  initProductBtmDescription();
  initTierPrice();
  initClearCart();
  initPrevPage();
  initProductListToggler();
  initFooterAccordions();
  initNumberFieldsWithNoDecimals();
  initQuickOrderButtons();
  initCartCsvDownload();
  initAddToCartAnimation();
  initDialogCloseButtons();
  initPriceCloakFallback();
  initCookieSettingsLinks();
});

function initTierPrice() {
  document.addEventListener('click', function(e) {
    const tierPriceContainer = e.target.tagName === 'VOLUME-PRICING' ? e.target : e.target.closest('volume-pricing');
    const clickedInsideProductInfo = e.target.closest('.product__info-wrapper');

    if (!tierPriceContainer) return;

    if (tierPriceContainer && !clickedInsideProductInfo) {
      const isOpen = tierPriceContainer.dataset.open === 'true';
      tierPriceContainer.dataset.open = (!isOpen).toString();

      tierPriceContainer.addEventListener("mouseleave", () => {
        tierPriceContainer.dataset.open = 'false';
      });
    }

    const volumePricingItem = e.target.closest('button');
    const itemTextHtml = volumePricingItem?.querySelector('span')?.innerHTML;
    const leadingDigitsMatch = itemTextHtml?.match(/^(\d+)/);

    if (!leadingDigitsMatch) return;

    const volumeMultiplier = parseInt(leadingDigitsMatch[1], 10);
    const productCode = volumePricingItem?.dataset.productId;

    if (clickedInsideProductInfo) {
      const volumeInput = document.querySelector('input.quantity__input');

      if (!volumeInput) return;

      const currentVal = Number(volumeInput.value) || 0;
      const minVal = Number(volumeInput.dataset.min) || 1;
      let newValue = currentVal + volumeMultiplier;

      if (currentVal === minVal && volumeMultiplier !== minVal) {
        newValue = volumeMultiplier;
      }

      volumeInput.value = newValue;
      volumeInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const inputScope = tierPriceContainer.closest('.card-wrapper') ?? tierPriceContainer.closest('form') ?? document;
    const volumeInputs = inputScope.querySelectorAll(`.quantity__input[data-quantity-variant-id="${productCode}"]`);

    if (volumeInputs.length > 0 && !clickedInsideProductInfo) {
      volumeInputs.forEach((input) => {
        const currentVal = Number(input.value) || 0;
        const minVal = Number(input.dataset.min) || 1;
        let newValue = currentVal + volumeMultiplier;

        if (currentVal === minVal && volumeMultiplier !== minVal) {
          newValue = volumeMultiplier;
        }

        input.value = newValue;
      });

      const lastInput = volumeInputs[volumeInputs.length - 1];
      lastInput.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { animationOrigin: volumePricingItem } }));
    }
  });
};

function initProductBtmDescription() {
  const descToggle = document.getElementById("product-btm__description-button");

  const description = document.getElementById("product-btm__description");
  const descToggleSpan = document.getElementById("description-button__text");
  const descToggleIcon = document.querySelector(
    '#product-btm__description-button .icon-caret'
  );

  if (!description || !descToggle || !descToggleSpan) {
    console.warn("Product description read more component is missing elements.");
    return;
  }

  const isOverflowing = description.clientHeight === Number(description.dataset.height);
  descToggle.hidden = !isOverflowing;

  descToggle.addEventListener("click", () => {
    const isExpanded = descToggle.getAttribute("aria-expanded") === "true";
    descToggle.setAttribute("aria-expanded", String(!isExpanded));

    description.classList.toggle("is-expanded", !isExpanded);

    const showMoreText = descToggle.getAttribute("data-show-more") || "Show more";
    const showLessText = descToggle.getAttribute("data-show-less") || "Show less";

    descToggleSpan.textContent = isExpanded ? showMoreText : showLessText;
    descToggleIcon?.classList.toggle("rotate-180", !isExpanded);
  });
};


function initClearCart(){
  const clearCart = document.getElementById('mbm_clear_cart');

  if (clearCart) {
    clearCart.addEventListener('click', (event) => {
      event.preventDefault();

      const confirmMessage = clearCart.dataset.confirm;
      const confirmClear = confirm(confirmMessage);

      if (!confirmClear) {
        return;
      }

      fetch('/cart/clear.js', { method: 'POST' })
        .then(() => location.reload())
        .catch((error) => console.error('Error clearing cart:', error));
    });
  }
}

function initPrevPage() {
  const prevPageButtons = document.querySelectorAll('[data-action="continue-shopping"]');

  prevPageButtons.forEach(button => {
    button.addEventListener("click", () => {

      const prevUrl = document.referrer;
      const currentHost = window.location.hostname;

      if (!prevUrl) {
        window.location.href = '/';
        return;
      }

      try {
        const referrer = new URL(prevUrl);
        if (referrer.hostname !== currentHost) {
          window.location.href = '/';
        } else {
          history.back();
        }
      } catch {
        window.location.href = '/';
      }
    });
  });
}

function initProductListToggler() {
  const variantsList = document.querySelector('[data-product-variants]');
  const toggler = document.querySelector('[data-action="toggle-product-variants"]');

  if (!variantsList || !toggler) return;

  const togglerText = toggler.querySelector('#variant-toggler-button__text');
  const toggleIcon = toggler.querySelector('.icon-caret');
  const showMore = toggler.dataset?.showMore;
  const showLess = toggler.dataset?.showLess;

  toggler.addEventListener('click', () => {
    const isExpanded = toggler.getAttribute('aria-expanded') === 'true';

    toggler.setAttribute('aria-expanded', String(!isExpanded));
    variantsList.dataset.expanded = String(!isExpanded);

    if (togglerText) togglerText.innerText = !isExpanded ? showLess : showMore;
    if (toggleIcon) toggleIcon.classList.toggle('rotate-180', !isExpanded);
  });
}

function initFooterAccordions() {
  const footerHeadings = document.querySelectorAll('.footer-block--menu .footer-block__heading');

  for(let i = 0; i < footerHeadings.length; i++) {
    const footerHeading = footerHeadings[i];

    footerHeading.addEventListener('click', (e) => {
      e.target.parentNode.classList.toggle('open');
    });
  }
}

function initNumberFieldsWithNoDecimals() {
  document.querySelectorAll('.input-number-no-decimals').forEach((input) => {
    input.addEventListener('keydown', (event) => {
      if(event.key === '.' || event.key === ',') {
        event.preventDefault();
      }
    });

    input.addEventListener('keyup', (event) => {
      event.target.value = event.target.value.replace(/[^0-9]*/g, '');
    });
  });
}

function initQuickOrderButtons() {
  // global.js already takes care of the product card input handeling
  // this changed the add to cart behavior to add products using a button manually

  let manualAddQueue = Promise.resolve();

  document.addEventListener('click', function(e) {
    const manualButton = e.target.closest('[data-action="quick-order-manual"]');
    if (!manualButton) return;
    
    const productCardAction = manualButton.closest('.product-card-action');

    const quickAddBulk = productCardAction.querySelector('.quick-add-bulk[data-manually-add-to-cart="true"]');

    if (!quickAddBulk) return;
    manualAddQueue = manualAddQueue.then(() => addToCartManual(quickAddBulk, manualButton));
  });

  function addToCartManual(quickAddBulk, triggerButton) {
    const input = quickAddBulk.querySelector('input');

    if (!input) return Promise.resolve();

    const quantity = parseInt(input.value);
    const variantId = quickAddBulk.dataset.index;

    if (quantity <= 0 || !variantId) return Promise.resolve();

    const progressBar = quickAddBulk.querySelector('.progress-bar-container');
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (progressBar) progressBar.classList.remove('hidden', 'error', 'success');

    // Prepare form data with sections like product-form.js does
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    // Add to cart using Shopify Cart API
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }
      return response.json();
    })
    .then((response) => {
      input.value = input.min;

      const buttonMinus = quickAddBulk.querySelector(".quantity__button[name='minus']");
      if (buttonMinus) buttonMinus.classList.add('disabled');

      if (progressBar) {
        progressBar.classList.add('success');
        setTimeout(() => {
          progressBar.classList.add('hidden');
        }, 1500);
      }

      // Use cart's renderContents method to properly update all sections
      if (cart) {
        cart.renderContents(response);
      }

      // Publish cart update event after renderContents to avoid duplicate triggers
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'quick-add-manual',
          productVariantId: variantId,
          cartData: response,
          triggerButton
        });
      }
    })
    .catch(error => {
      console.error('Error adding to cart:', error);

      if (progressBar) {
        progressBar.classList.add('error');
        setTimeout(() => {
          progressBar.classList.add('hidden');
        }, 3000);
      }
    });
  }
  
  const notifyStockButtons = document.querySelectorAll('.product-card-action__button[href="/pages/contact"]');

  notifyStockButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      let notifyStockCollectionButton = null;
      
      if (document.querySelector('product-form')) {
        notifyStockCollectionButton = document.querySelector('.gw-button-widget');
      } else {
        notifyStockCollectionButton = e.target.closest('.card__content')?.querySelector('.gw-collection-page-button');
      }

      if (notifyStockCollectionButton) {
        notifyStockCollectionButton.click();
      }
    });
  });
}

function initCartCsvDownload() {
  const btn = document.getElementById('cart-csv-download-btn');
  if (!btn) return;

  btn.addEventListener('click', function () {
    const dataEl = document.getElementById('cart-csv-data');
    if (!dataEl) return;

    const items = JSON.parse(dataEl.textContent);
    const rows = [['sku', 'quantity']];

    items.forEach(function (item) {
      rows.push([item.sku, item.quantity]);
    });

    const csv = rows.map(function (row) {
      return row.map(function (cell) {
        return '"' + String(cell ?? '').replace(/"/g, '""') + '"';
      }).join(',');
    }).join('\n');

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'cart.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  });
}

function initAddToCartAnimation() {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
    const cartIcon = document.getElementById("cart-icon-bubble");
    const active = document.activeElement;
    let origin = null;
    let productImage = null;

    switch (data.source) {
      case "QuickOrderForm":
        if (!data.animations) return;
        [...data.animations.values()].forEach(({ origin: o, image }, i) => {
          const launch = () => {
            setTimeout(() => {
              if (!o || !cartIcon) return;
              const el = document.createElement("fly-to-cart");
              if (image) el.style.setProperty("background-image", `url(${image})`);
              el.source = o;
              el.destination = cartIcon;
              document.body.appendChild(el);
            }, i * 150);
          };
          if (image) {
            const img = new Image();
            img.onload = launch;
            img.onerror = launch;
            img.src = image;
          } else {
            launch();
          }
        });
        return;
      case "quick-add-manual":
        origin = data.triggerButton ?? active;
        productImage = origin?.closest(".card-wrapper")?.querySelector(".card__media img")?.currentSrc ?? null;
        break;
      case "product-form":
        origin = active;
        productImage = document.querySelector(".product__media-wrapper img")?.src ?? null;
        break;
    }

    if (!origin || !cartIcon) return;

    const el = document.createElement("fly-to-cart");
    if (productImage) el.style.setProperty("background-image", `url(${productImage})`);
    el.source = origin;
    el.destination = cartIcon;
    document.body.appendChild(el);
  });

  function animateCartIcon() {
    const cartIcon = document.getElementById("cart-icon-bubble");
    if (!cartIcon) return;
    cartIcon.classList.remove("cart-icon--pop");
    void cartIcon.offsetWidth;
    cartIcon.classList.add("cart-icon--pop");
    cartIcon.addEventListener("animationend", () => cartIcon.classList.remove("cart-icon--pop"), { once: true });
  }

  function bezierPoint(t, p0, p1, p2, p3) {
    const cx = 3 * (p1.x - p0.x), bx = 3 * (p2.x - p1.x) - cx, ax = p3.x - p0.x - cx - bx;
    const cy = 3 * (p1.y - p0.y), by = 3 * (p2.y - p1.y) - cy, ay = p3.y - p0.y - cy - by;
    return {
      x: ax * t ** 3 + bx * t ** 2 + cx * t + p0.x,
      y: ay * t ** 3 + by * t ** 2 + cy * t + p0.y,
    };
  }

  class FlyToCart extends HTMLElement {
    source;
    destination;

    connectedCallback() {
      const offset = 30;
      const src = this.source.getBoundingClientRect();
      const dst = this.destination.getBoundingClientRect();
      const start = { x: src.left + src.width / 2 - offset, y: src.top + src.height / 2 - offset };

      this.style.setProperty('--x', `${start.x}px`);
      this.style.setProperty('--y', `${start.y}px`);
      this.style.setProperty('--scale', '1');
      this.style.opacity = '1';

      let startTime = null;
      const duration = 800;

      const animate = (t) => {
        if (!startTime) startTime = t;
        const progress = Math.min((t - startTime) / duration, 1);

        const dst = this.destination.getBoundingClientRect();
        const end = { x: dst.left + dst.width / 2 - offset, y: dst.top + dst.height / 2 - offset };
        const cp1 = { x: start.x, y: start.y - 200 };
        const cp2 = { x: end.x - 300, y: end.y - 100 };

        const pos = bezierPoint(progress, start, cp1, cp2, end);
        this.style.setProperty('--x', `${pos.x}px`);
        this.style.setProperty('--y', `${pos.y}px`);
        this.style.setProperty('--scale', `${1 - progress * 0.5}`);
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          this.style.opacity = '0';
          setTimeout(() => { this.remove(); animateCartIcon(); }, 200);
        }
      };

      requestAnimationFrame(animate);
    }
  }

  if (!customElements.get('fly-to-cart')) {
    customElements.define('fly-to-cart', FlyToCart);
  }
}

// MbM - fallback for the price cloak (see mbm-custom.css). App reveals discounted items via
// .pi-injected; non-discounted never get it, so after a grace period add .pi-ready to reveal.
// Re-runs after each AJAX grid swap (pi:grid-updated) for filtered/sorted results.
function initPriceCloakFallback() {
  const reveal = () => {
    window.setTimeout(() => {
      document
        .querySelectorAll('.card-product__price-wrapper:not(:has(.pi-injected)):not(.pi-ready)')
        .forEach(wrapper => wrapper.classList.add('pi-ready'));
      document
        .querySelectorAll('.card-wrapper volume-pricing:not(.pi-vol-ready):not(.pi-ready)')
        .forEach(volumeEl => volumeEl.classList.add('pi-ready'));
      document
        .querySelectorAll('product-info .price:not(:has(.pi-injected)):not(.pi-ready)')
        .forEach(priceEl => priceEl.classList.add('pi-ready'));
      document
        .querySelectorAll('product-info volume-pricing:not(.pi-vol-ready):not(.pi-ready)')
        .forEach(volumeEl => volumeEl.classList.add('pi-ready'));
    }, 1500);
  };

  reveal();
  document.addEventListener('pi:grid-updated', reveal);

  // <product-recommendations> (related products) loads lazily and swaps in cards with
  // no event of its own, so re-run reveal() once its cards actually land in the DOM.
  document.querySelectorAll('product-recommendations').forEach((el) => {
    const observer = new MutationObserver(() => {
      if (el.querySelector('.grid__item')) {
        observer.disconnect();
        reveal();
      }
    });
    observer.observe(el, { childList: true });
  });
}

function initDialogCloseButtons() {
  const dialogCloseButtons = document.querySelectorAll('.dialog-close');

  dialogCloseButtons.forEach(dialogCloseButton => {
    dialogCloseButton.addEventListener('click', (e) => {
      e.preventDefault();
      
      const dialog = e.target.parentNode;
      dialog.close();
    })
  });
}

function initCookieSettingsLinks() {
  for (const button of document.querySelectorAll('[data-cookiebot-renew]')) {
    button.addEventListener('click', () => window.Cookiebot?.renew());
  }
}
